import React, { useEffect } from 'react';
import { LogoLoadingIndicator } from '@/components/logo-loading-indicator';
import { PricingBookmarksScreen } from '@/experiences/sales-portal/domain/pricing/screens/bookmarks/pricing-bookmarks-screen';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesPortalStackParams } from '@/navigators/types';
import { StackNavigationProp, StackScreenProps } from '@react-navigation/stack';
import { useBusinessOrganizationPricingConfig } from '@/experiences/sales-portal/blocs/hooks/use-business-organization-pricing-config';
import { useNavigation } from '@react-navigation/native';

type Props = StackScreenProps<
  SalesPortalStackParams,
  typeof SALES_PORTAL_ROUTES.PricingBookmarked
>;

export const PricingBookmarksScreenWrapper: React.FC<Props> = (props) => {
  const navigation =
    useNavigation<StackNavigationProp<SalesPortalStackParams>>();

  const { loading, error, hasPricingAccess } =
    useBusinessOrganizationPricingConfig();

  useEffect(() => {
    if (!loading && !error && !hasPricingAccess) {
      navigation.replace(SALES_PORTAL_ROUTES.NotFound);
    }
  }, [error, hasPricingAccess, loading, navigation]);

  // Bookmarking-disabled or empty-bookmark cases resolve to a redirect inside
  // the screen (to Cost Changes), so no NotFound gate on hasBookmarkingAccess.
  return loading ? (
    <LogoLoadingIndicator />
  ) : (
    <PricingBookmarksScreen {...props} />
  );
};
